import { createFileRoute } from '@tanstack/react-router'
import {TutorForm} from '@/features/tutors/components/tutor-form'

export const Route = createFileRoute('/_authenticated/tutors/create')({
  component: CreateTutor,
})

function CreateTutor() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Create Tutor</h1>
      <TutorForm tutor={null} />
    </div>
  )
}
